import { ModalCompAdvance } from "../Ui/ModalComp";
import { ButtonComp } from "..";
import { investorButtonProps } from "./investorButtonStyles";

export default function InvestorModal({
  show,
  onClose,
  title,
  children,
  footer,
  size = "md",
}) {
  return (
    <ModalCompAdvance
      show={show}
      handleClose={onClose}
      close
      footerClose={false}
      centered
      size={size}
      modalBody={0}
      arrayComp={[
        {
          component: (
            <div>
              {title ? (
                <h5 className="fw-bold mb-3 pe-4" style={{ color: "#383838" }}>
                  {title}
                </h5>
              ) : null}
              <div className="investor-modal-body">{children}</div>
              {footer ? (
                <div className="d-flex flex-column flex-sm-row gap-2 justify-content-end mt-4 pt-2 border-top">
                  {footer}
                </div>
              ) : null}
            </div>
          ),
        },
      ]}
    />
  );
}

export function InvestorModalActions({
  onCancel,
  onConfirm,
  cancelText = "Cancel",
  confirmText = "Confirm",
  confirmVariant = "primary",
  loading,
  confirmDisabled = false,
}) {
  return (
    <div className="d-flex flex-column-reverse flex-sm-row gap-2 justify-content-end align-items-stretch mt-3 pt-3 border-top">
      <ButtonComp
        type="button"
        btnText={cancelText}
        onClick={onCancel}
        btnClassName="flex-fill flex-sm-grow-0"
        {...investorButtonProps.outline}
        ButtonInlineStyle={{
          ...investorButtonProps.outline.ButtonInlineStyle,
          width: "auto",
          minWidth: 120,
        }}
      />
      <ButtonComp
        type="button"
        btnText={confirmText}
        onClick={onConfirm}
        loading={loading}
        disabled={confirmDisabled || loading}
        btnClassName="flex-fill flex-sm-grow-0"
        {...investorButtonProps[confirmVariant]}
        ButtonInlineStyle={{
          ...investorButtonProps[confirmVariant].ButtonInlineStyle,
          width: "auto",
          minWidth: 140,
        }}
      />
    </div>
  );
}
